import React from "react";
import "../static/css/Connect.css";

const Connect = () => {
  return (
    <>
      <div className="connect">
        <div className="connect-component">
          <div className="connect-text">
            <p>CHANGE LEADS TO TRANSFORMATION</p>
          </div>
          <div className="connect-line"></div>
          <div className="connect-button">
            <a
              href="https://quindl.com/contactus"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>CONNECT WITH US</button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Connect;
